import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
    token: sessionStorage.getItem('token') || '',
    tenantId: sessionStorage.getItem('tenantId') || '',
    userInfo: sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : null,
    buttonPermissions: JSON.parse(sessionStorage.getItem('buttonPermissions') || '[]'),
  }),
  actions: {
    setToken(token) {
      this.token = token
      sessionStorage.setItem('token', token)
    },
    setTenantId(tenantId) {
      this.tenantId = tenantId
      sessionStorage.setItem('tenantId', tenantId)
    },
    setUserInfo(info) {
      this.userInfo = info
      sessionStorage.setItem('userInfo', JSON.stringify(info))
    },
    setButtonPermissions(permissions) {
      this.buttonPermissions = permissions
      sessionStorage.setItem('buttonPermissions', JSON.stringify(permissions))
    },
    logout() {
      this.token = ''
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('userInfo')
      sessionStorage.removeItem('buttonPermissions')
      this.userInfo = null
      this.buttonPermissions = []
    },
  },
})
